function initCartDrawerSwiper() {
  if (window.innerWidth > 767) {
    new Swiper(".cartDrawer-carousel", {
      slidesPerView: 2,
      spaceBetween: 6,
      slidesPerGroup: 2,
      loop: false,
      autoHeight: false,
      centerInsufficientSlides: true,
      resistance: false,            // disable resistance/bounce at edges
      resistanceRatio: 0.6,           // set ratio to 0 for no bounce effect
      touchMoveStopPropagation: true, // stop touchmove propagation up
      freeMode: {
        enabled: true,     // enables free scrolling
      },
      navigation: {
        nextEl: ".slider-button--next",
        prevEl: ".slider-button--prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}

function initVisualNavigationSwiper() {
  if (window.innerWidth > 767) {
    new Swiper(".visualNavigation-carousel", {
      slidesPerView: 6.5,
      spaceBetween: 25,
    });
  }
}

function initMobileSwiper() {
  if (window.innerWidth <= 767) {
    new Swiper(".mobileSwiper-carousel", {
      slidesPerView: 2,
      spaceBetween: 6,
      slidesPerGroup: 2,
      loop: false,
      autoHeight: false,
      centerInsufficientSlides: true,
      resistance: false,            // disable resistance/bounce at edges
      resistanceRatio: 0.6,           // set ratio to 0 for no bounce effect
      touchMoveStopPropagation: true, // stop touchmove propagation up
      freeMode: {
        enabled: true,     // enables free scrolling
      },
      navigation: {
        nextEl: ".slider-button--next",
        prevEl: ".slider-button--prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}

function parseSlidesPerView(value, fallback) {
  var parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

var relatedProductsDesktopMq = window.matchMedia('(min-width: 768px)');

function destroyRelatedProductsSwiper(carousel) {
  if (carousel.swiper && !carousel.swiper.destroyed) {
    carousel.swiper.destroy(true, true);
  }
}

function initRelatedProductsSwiper(root) {
  if (typeof Swiper === 'undefined') return;

  var scope = root && root.querySelectorAll ? root : document;
  var carousels = scope.querySelectorAll('[data-related-products-swiper].swiper');
  var isDesktop = relatedProductsDesktopMq.matches;

  carousels.forEach(function (carousel) {
    if (carousel.querySelector('.related-products__skeleton')) return;
    if (!carousel.querySelector('.swiper-slide')) return;

    var wantsCssMode = !isDesktop;
    var existing = carousel.swiper && !carousel.swiper.destroyed ? carousel.swiper : null;

    if (existing) {
      if (Boolean(existing.params.cssMode) === wantsCssMode) return;
      destroyRelatedProductsSwiper(carousel);
    }

    var slidesDesktop = parseSlidesPerView(carousel.getAttribute('data-slides-desktop'), 5);
    var slidesMobile = parseSlidesPerView(carousel.getAttribute('data-slides-mobile'), 2);
    var nextEl = carousel.querySelector('.slider-button--next');
    var prevEl = carousel.querySelector('.slider-button--prev');
    var config = {
      watchOverflow: true,
      loop: false,
      speed: 400,
      autoHeight: false,
    };

    if (wantsCssMode) {
      config.slidesPerView = slidesMobile;
      config.slidesPerGroup = 1;
      config.spaceBetween = 6;
      config.cssMode = true;
      config.freeMode = {
        enabled: true,
        momentum: true,
        momentumBounce: false,
      };
    } else {
      config.slidesPerView = slidesDesktop;
      config.slidesPerGroup = slidesDesktop;
      config.spaceBetween = 25;
      config.cssMode = false;
      config.simulateTouch = true;
      config.resistance = false;
      config.resistanceRatio = 0.6;
      config.touchMoveStopPropagation = true;
      config.freeMode = {
        enabled: true,
      };
      if (nextEl && prevEl) {
        config.navigation = {
          nextEl: nextEl,
          prevEl: prevEl,
        };
      }
    }

    new Swiper(carousel, config);
  });
}

window.initRelatedProductsSwiper = initRelatedProductsSwiper;

function bindRelatedProductsSwiperBreakpoint() {
  if (window.__relatedProductsSwiperMqBound) return;
  window.__relatedProductsSwiperMqBound = true;

  var onBreakpointChange = function () {
    initRelatedProductsSwiper();
  };

  if (typeof relatedProductsDesktopMq.addEventListener === 'function') {
    relatedProductsDesktopMq.addEventListener('change', onBreakpointChange);
  } else if (typeof relatedProductsDesktopMq.addListener === 'function') {
    relatedProductsDesktopMq.addListener(onBreakpointChange);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  bindRelatedProductsSwiperBreakpoint();
  initRelatedProductsSwiper();
});

document.addEventListener('shopify:section:load', function (event) {
  bindRelatedProductsSwiperBreakpoint();
  initRelatedProductsSwiper(event.target);
});